import React from 'react';
import { connect } from 'react-redux';

import './style.scss';

const Description = ({ packageList }) => (
    <tr className="description">
        <th/>
        {
            packageList.map((packageData) => (
                <td key={packageData.id}>
                    {packageData.description}
                </td>
            ))
        }
    </tr>
);

const mapStateToProps = ({ packages }) => ({
    packageList: packages.packageList
});

export { Description };
export default connect(mapStateToProps)(Description);
